//import library
import autoComplete from "@tarekraafat/autocomplete.js";
import "./autocomplete.css";

export default {
  init(moduleName) {
    const elements = document.querySelectorAll(".autocomplete");
    elements.forEach(function (element) {
      const url = `/api/autocomplete?table=${moduleName}`;
      new autoComplete({
        data: {
          src: async () => {
            const query = document.querySelector(`#${element.id}`).value;
            const source = await fetch(
              `${url}&column=${element.id}&query=${query}`
            );
            const data = await source.json();
            return data;
          },
          key: ["value"],
          cache: false,
        },
        selector: `#${element.id}`,
        resultsList: {
          render: true,
          destination: document.querySelector(`#${element.id}`),
        },
        threshold: 2,
        debounce: 500,
        maxResults: 5,
        highlight: true,
        resultItem: {
          content: (data, source) => {
            source.innerHTML = data.match;
          },
          element: "li",
        },
        // noResults: () => {
        //   // const result = document.createElement("li");
        //   // result.setAttribute("class", "autoComplete_result text-danger");
        //   // result.setAttribute("tabindex", "1");
        //   // result.innerHTML = "Sonuç Bulunamadı";
        //   // const container = document.querySelector("#autoComplete_list");
        //   // container.appendChild(result);
        // },
        onSelection: (feedback) => {
          let selection = feedback.selection.value;
          let element = document.querySelector(`#${selection.selector}`);
          element.value = selection.value;
          setTimeout(() => {
            element.focus();
          }, 100);
        },
      });
    });
  },
};
